var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.openRatingReviewsModal()}}},[_vm._v(" "+_vm._s(_vm.ratings_received)+" "+_vm._s(_vm.ratings_received > 1 ? "avaliações" : "avaliação")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }